/* eslint-disable prettier/prettier */
<template>
  <div>
    <!--begin::Head-->

    <!--end::Head-->

    <!--begin::Body-->
    <div class="kt-login__body">
      <!--begin::Signin-->
      <div class="kt-login__form">
        <!--begin::Form-->
        <b-form
          class="kt-form form elevation-1"
          @submit.stop.prevent="onSubmit"
        >
          <div class="div heading">
            <h2 class="form-heading">PAYNOWPRO</h2>
            <p>Confirm Account</p>
          </div>
          <div
            role="alert"
            v-bind:class="{ show: pageErrors.length }"
            class="alert fade alert-danger"
          >
            <div class="alert-text">
              {{ pageErrors }}
            </div>
          </div>

          <b-form-group
            id="email-input-group"
            class="form-group"
            label
            label-for="email"
            ><label class="d1-block">Email Address</label>
            <b-form-input
              class="input"
              id="email-input"
              name="email"
              ref="emailField"
              v-model="$v.form.email.$model"
              :state="validateState('email')"
              aria-describedby="email-feedback"
              placeholder=""
              readonly
            ></b-form-input>

            <b-form-invalid-feedback id="email-feedback"
              >A valid email address is required.</b-form-invalid-feedback
            >
          </b-form-group>

          <b-form-group
            id="password-input-group"
            class="form-group"
            label
            label-for="password"
            ><label class="d1-block">New Password</label>
            <b-form-input
              class="input"
              type="password"
              id="password"
              name="password"
              v-model="$v.form.password.$model"
              :state="validateState('password')"
              aria-describedby="password-feedback"
              placeholder=""
            ></b-form-input>

            <b-form-invalid-feedback id="password-feedback">{{
              invalidPasswordMessage
            }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            id="confirm-password-input-group"
            class="form-group"
            label
            label-for="confirm-password"
            ><label class="d1-block">Confirm Password</label>
            <b-form-input
              class="input"
              type="password"
              id="confirm-password"
              name="confirm"
              v-model="$v.form.confirm.$model"
              :state="validateState('confirm')"
              aria-describedby="confirm-password-feedback"
              placeholder=""
            ></b-form-input>

            <b-form-invalid-feedback
              v-if="!$v.form.confirm.sameAs"
              id="confirm-password-feedback"
              >Passwords must match</b-form-invalid-feedback
            >
          </b-form-group>
          <!--begin::Action-->
          <div class="kt-login__actions confirm-actions">
            <b-button
              id="kt_submit"
              type="submit"
              class="btn btn-auth login-btn-auth btn-primary btn-elevate kt-login__btn-primary kt-spinner--light kt-spinner--right"
              >Confirm Account</b-button
            >
            <span class="kt-login__signup-label">Already have an account?</span
            >&nbsp;&nbsp;
            <router-link
              class="kt-link kt-login__signup-link"
              :to="{ name: 'login' }"
              >Login!</router-link
            >
          </div>
          <!--end::Action-->
        </b-form>
        <!--end::Options-->
      </div>
      <!--end::Signin-->
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import "./auth.css";
import { mapState } from "vuex";
import { COMPLETE_NEW_PASSWORD } from "@/store/auth.module";
import { LOGOUT } from "@/store/auth.module";
import { Auth } from "aws-amplify";
import { validationMixin } from "vuelidate";
import { email, required, minLength, sameAs } from "vuelidate/lib/validators";
import PasswordValidationMixin from "@/components/widgets/PasswordValidationMixin.js";

const passwordValidationMixin = PasswordValidationMixin(
  "password",
  true,
  "form"
);

export default {
  mixins: [validationMixin, passwordValidationMixin],
  beforeRouteEnter(to, from, next) {
    var email = to.params.email;
    next(vm => {
      vm.form.email = email;
    });
  },
  data() {
    return {
      form: {
        email: null,
        password: null,
        confirm: null
      },
      pageErrors: ""
    };
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: passwordValidationMixin.passwordValidation,
      confirm: {
        required,
        sameAsPassword: sameAs("password")
      }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name] ?? this.$v.confirm[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        email: null,
        password: null,
        comfirm: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    async onSubmit() {
      this.pageErrors = "";
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const email = this.$v.form.email.$model;
      const password = this.$v.form.password.$model;

      // set spinner to submit button
      const submitButton = document.getElementById("kt_submit");
      submitButton.classList.add("kt-spinner");

      this.$store
        .dispatch(COMPLETE_NEW_PASSWORD, password)
        // go to which page after successfully login
        .then(user => {
          this.$router.push({ name: "login" });
        })
        .catch(e => {
          this.$logger.error(e);
          this.pageErrors = !!this.errors
            ? this.errors
            : "There was an error confirming your account";
          submitButton.classList.remove(
            "kt-spinner",
            "kt-spinner--light",
            "kt-spinner--right"
          );
        });
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    backgroundImage() {
      return process.env.BASE_URL + "assets/media/bg/bg-4.jpg";
    }
  }
};
</script>
